<template>
<div>
  <v-container fluid class="my-5">
    <v-layout row wrap justify-end>
      <v-flex xs12 md3>
        <!-- here we trigger create client functions -->
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-data-table :headers="headers" :items="clients" class="elevation-1">
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {},
  data () {
    return {}
  },
  methods: {
    ...mapActions('admin', [
      'loadClients'
    ])
  },
  computed: {
    ...mapGetters('admin', [
      'clients'
    ]),
    headers () {
      return [
        { text: this.$t('views.adminClients.headerName'), value: 'name' },
        { text: this.$t('views.adminClients.headerCode'), value: 'code' },
        { text: this.$t('views.adminClients.headerActions'), value: 'action', sortable: false }
      ]
    }
  },
  created: function () {
    this.loadClients()
  }
}
</script>
